import { render, staticRenderFns } from "./HomeIdeasPlaceInfo.vue?vue&type=template&id=023e5241&scoped=true"
import script from "./HomeIdeasPlaceInfo.vue?vue&type=script&lang=ts"
export * from "./HomeIdeasPlaceInfo.vue?vue&type=script&lang=ts"
import style0 from "./HomeIdeasPlaceInfo.vue?vue&type=style&index=0&id=023e5241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023e5241",
  null
  
)

export default component.exports